import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiModelUpdateFailedAction = {
	type: 'AI_MODEL_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiModelUpdateFailedAction => ({
	type: 'AI_MODEL_UPDATE_FAILED',
	payload,
});
